(() => {
  const root = document.querySelector('.article-template__content');
  if (!root) return;
  const handleFailure = image => {
    if (image.dataset.rljMediaFailed) return;
    image.dataset.rljMediaFailed = 'true';
    const related = image.closest('.zemanta-related-posts, .zemanta-article-ul, .related_post, .related-posts');
    if (related) {
      image.hidden = true;
      return;
    }
    const alt = image.alt.trim();
    const replacement = document.createElement('span');
    replacement.className = 'rlj-media-unavailable';
    replacement.textContent = alt || root.dataset.mediaUnavailable;
    image.replaceWith(replacement);
  };
  root.querySelectorAll('img').forEach(image => {
    image.addEventListener('error', () => handleFailure(image), { once: true });
    if (image.complete && image.naturalWidth === 0) handleFailure(image);
  });
})();
